const pageHeadlineStyle = {
  headlineContainer: {
    margin: "0 2rem 2rem",
    textAlign: "center",
  },
};
export default pageHeadlineStyle;
